import { BlogMainSectionContainer } from 'components/Blog/BlogMainSection';
import React from 'react';
import styled from 'styled-components';
import EventCategoryTab from './EventCategoryTab';
import EventListSection from './EventListSection';
import EventSearchArea from './EventSearchArea';

const EventMainSection = () => {
  return (
    <EventMainSectionContainer>
      <div className="inner-container">
        {/* tab */}
        <EventCategoryTab />

        {/* section */}
        <EventSearchArea />

        {/* list */}
        <EventListSection />
      </div>
    </EventMainSectionContainer>
  );
};

export default EventMainSection;

const EventMainSectionContainer = styled(BlogMainSectionContainer)``;
